import app from "./bootstrap";

app().then((app) => {
  app.mount("#track-and-trace");
});
